import { FEED_CACHE_KEY } from "./storageKeys";

// The first screenful of the Home feed, kept on the device so the next visit can show it
// at once (the way Instagram does) while the fresh one is fetched. Without it a slow
// connection meant looking at grey loading placeholders until the server answered.
//
// It belongs to one account: it is only used for the same person (or for a visitor who
// isn't logged in), it is cleared on logout (see clearLocalUserData.js), and it is only
// trusted for a few days.

const VERSION = 1;
const MAX_AGE_MS = 3 * 24 * 60 * 60 * 1000;

export function readFeedCache(userId) {
  try {
    const raw = localStorage.getItem(FEED_CACHE_KEY);
    if (!raw) return null;

    const cache = JSON.parse(raw);
    if (!cache || cache.version !== VERSION) return null;
    if ((cache.userId ?? null) !== (userId ?? null)) return null;
    if (!cache.savedAt || Date.now() - cache.savedAt > MAX_AGE_MS) return null;
    if (!Array.isArray(cache.designs) || cache.designs.length === 0) return null;

    return {
      designs: cache.designs,
      followingIds: Array.isArray(cache.followingIds) ? cache.followingIds : [],
      blockedIds: Array.isArray(cache.blockedIds) ? cache.blockedIds : [],
      mutedIds: Array.isArray(cache.mutedIds) ? cache.mutedIds : [],
      hasMoreSuggested: cache.hasMoreSuggested !== false
    };
  } catch {
    return null;
  }
}

export function writeFeedCache(userId, { designs, followingIds, blockedIds, mutedIds, hasMoreSuggested }) {
  try {
    // Nothing worth keeping (a failed or empty load): leave the earlier copy as it is.
    if (!designs || designs.length === 0) return;

    localStorage.setItem(
      FEED_CACHE_KEY,
      JSON.stringify({
        version: VERSION,
        userId: userId ?? null,
        savedAt: Date.now(),
        designs,
        followingIds,
        blockedIds,
        mutedIds,
        hasMoreSuggested
      })
    );
  } catch {
    // storage full or blocked — the next visit just shows the loading placeholders as before
  }
}
